// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 20px;
  background: #fff;
}

.graph-header {
  background-color: #0066b2;
  color: #fff;
  font-weight: 500;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px 4px 0 0;
}

.graph-body {
  padding: 16px;
}

.chart-wrapper {
  position: relative;
  height: 350px;
}

.no-data {
  text-align: center;
  color: #8c8f93;
  padding: 60px 20px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/rheological-hierarchy/graph/rheology100-so/rheology100-so.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".graph-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  background: #fff;\n}\n\n.graph-header {\n  background-color: #0066b2;\n  color: #fff;\n  font-weight: 500;\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 4px 4px 0 0;\n}\n\n.graph-body {\n  padding: 16px;\n}\n\n.chart-wrapper {\n  position: relative;\n  height: 350px;\n}\n\n.no-data {\n  text-align: center;\n  color: #8c8f93;\n  padding: 60px 20px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
